import { frontendURL } from '../../../../helper/URLHelper';
import SettingsShellWrapper from '../SettingsShellWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/blocked-contacts'),
      component: SettingsShellWrapper,
      children: [
        {
          path: '',
          name: 'blocked_contacts_list',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
